import { useEffect } from "react";
import isFastNet from "isfastnet";
import { atom, useRecoilState } from "recoil";

import { useFabricFeatureFlag } from "../next/hooks";

// Do NOT export atoms.
// This allows us to limit usage of these to only the hooks we export below.

const isNetworkFastAtom = atom<boolean | undefined>({
  key: "[@fabric/core] isNetworkFastAtom",
  default: undefined,
});

// ######################
// ## useIsNetworkFast ##
// ######################

export type ResultOfUseIsNetworkFast = boolean | undefined;
export type UseIsNetworkFast = () => ResultOfUseIsNetworkFast;

export const useIsNetworkFast: UseIsNetworkFast = () => {
  const [isNetworkFast, setIsNetworkFast] = useRecoilState(isNetworkFastAtom);

  const coreNetworkSpeedTesterFF = useFabricFeatureFlag({
    key: "core-network-speed-tester",
    ignoreUserId: true,
    ignoreOperationId: true,
  });

  useEffect(() => {
    if (isNetworkFast === undefined && coreNetworkSpeedTesterFF) {
      isFastNet(
        (isFast) => {
          setIsNetworkFast(isFast);
        },
        { timesToTest: 3 },
      );
    }
  }, [isNetworkFast, coreNetworkSpeedTesterFF, setIsNetworkFast]);

  return isNetworkFast;
};
